import { z } from "zod";

import { apiErrorSchema } from "@workspace/schemas/errors";

// Extend base schema with optional details array (only present on conflict responses)
const frontendApiErrorSchema = apiErrorSchema.extend({
  details: z.array(z.unknown()).optional(),
});

/** Extract structured error from a failed API response */
export async function extractApiError(response: Response) {
  try {
    const result = frontendApiErrorSchema.safeParse(await response.json());
    if (result.success) return result.data;
  } catch {
    // JSON parse failure — fall through
  }
  return { error: "Unknown", message: response.statusText };
}

/** Custom error class that preserves the structured API error */
export class ApiResponseError extends Error {
  constructor(
    public readonly status: number,
    public readonly errorCode: string | undefined,
    public readonly details: unknown[] | undefined,
    message: string,
  ) {
    super(message);
    this.name = "ApiResponseError";
  }
}
